<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">

                    <div class="list-group-item">
                            <div  class="col-md-12">
                                        <h5 v-if="myFSDetails.length>0">Review (and Refocus on) each of your Life-Areas:
                                        <p><span v-if="reviewMessage==''" style="font-size:small;color:brown;"><b>Review Time: {{ elapsedTime }}  seconds.</b> (Need to spend {{elapsedTimeTarget}} seconds Reviewing &amp; Visualizing.)</span>
                                        <span v-if="!reviewMessage==''" style="font-size:small;color:brown;"><b>{{ reviewMessage }}</b><br/> (Needed to spend at least {{elapsedTimeTarget}} seconds Reviewing &amp; Visualizing.)</span></p>
                                        </h5>
                                    </div>


                            <div class="row">
                                <div v-if="myFSDetails.length>0">
                                    <div v-for="aDet in myFSDetails"  :key="aDet.life_area" class="col-auto col-12">
                                        <div class="content-box-gray card" >
                                        <div class="title text-center d-flex">
                                            <h6 class="mt-2" style="margin:auto;" v-html="aDet.life_area"></h6>
                                            <!-- <div  v-if="!readOnly" class="p-2"><i class="fas fa-trash float-right mx-2 fai-red" title="Delete" @click="doubleConfirmDeleteFSDetails(aDet.life_area)"></i>
                                            <i   v-if="!readOnly" class="fas fa-pen float-right mx-2 fai-blue" title="Update my Strategy" @click="editFSDetails(aDet.id)"></i></div> -->
                                        </div>
                                            <div class="content">
                                            <div class="card" style="padding:.5em;">
                                                    <h4>Vision:</h4>
                                                    <p v-html="aDet.vision"></p>
                                                    <!-- <h4>Standards &amp; Plan:</h4><i @click="habitPopup(aDet.life_area)" class="fas fa-plus fai-red">Supporting Habit</i> -->

                                                    <div class="row d-flex justify-content-between">
                                                        <h4 class="col-12">Standards &amp; Plan:</h4>
                                                        <!-- <i @click="habitPopup(aDet.life_area)" class="fas fa-plus fai-red col-6 text-right">Habit-Support</i> -->
                                                    </div>
                                                    <p v-html="aDet.plan"></p>
                                                    <div class="row d-flex justify-content-between">
                                                    <h4 class="col-12">Measure:</h4>
                                                        <!-- <i @click="myProgressPopup(aDet.life_area)" class="fas fa-eye fai-blue col-6 text-right">My Progress</i> -->
                                                    </div>
                                                    <p v-html="aDet.measure"></p>
                                                    <div class="d-flex flex-row justify-content-end">
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else><h4>No Future-Self Vision Areas to display.  Please set up first.</h4></div>

                        </div>
                    </div>

            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
var _ = require('lodash');

export default {
    components:{
     },
    name: "FSVisionDisplay",
    data() {
        return {
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                hc_add: '',
            },
            userData:'',
            myFSDetails:'',
            startTime:'',
            elapsedTime:'',
            reviewMessage:'',
            timerInterval:'',
            elapsedTimeTarget: 240,
      }
    },

    props: {

    },
    mounted() {
        this.getMyFSDetailsData();


    },

    methods: {
        getMyFSDetailsData() {
             console.log("getMyFSDetails: " );
              axios.get('/fself/viewinsert')
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.userData =JSON.parse(res.data.userdata);
                this.myFSDetails =JSON.parse(res.data.myfsdetails);
                // console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
                this.message = '';
                if(this.myFSDetails.length > 0) {
                    this.startTime = new Date();
                    this.startTimer();
                }
            });
        },
        startTimer() {
            this.timerInterval = setInterval(() => {
            const currentTime = new Date();
            this.elapsedTime = Math.floor(
                (currentTime - this.startTime) / 1000
            );
            }, 1000);
            console.error(this.elapsedTime);
            if(this.elapsedTime >= this.elapsedTimeTarget) {
            console.error('Review  time achieved for ' + this.userinfo.id);
                this.recordFSReview();
                this.reviewMessage ="Great job!";
                this.stopTimer();
            }
        },
        stopTimer() {
            clearInterval(this.timerInterval);
        },
        recordFSReview() {
            console.error('Recording review for ' + this.userData.id);
             axios.post('/fself/review/save', {
                user_id:this.userData.id,
            })
            .then(res => {
                this.reviewMessage = res.data.message;
                this.stopTimer();
                console.error(res.data.message);
            })
            .catch(err => {               ;
                console.error(err);
            })
            .finally(()=> {
                  this.updateToast(this.reviewMessage, 4000);
            });
        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },



    },
    watch: {
        elapsedTime(newValue) {
            if (newValue === this.elapsedTimeTarget) {
            this.recordFSReview();
            }
        }
    },
}
</script>

<style scoped>
.content-box-gray .content {
    overflow:auto    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#ffc107;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
/* https://code.tutsplus.com/tutorials/create-a-sticky-note-effect-in-5-easy-steps-with-css3-and-html5--net-13934 */
@media only screen and (min-width: 768px) {
    h6 {
    font-family:  Kalam;/** 'Reenie Beanie'; */
    font-weight: bold;
    font-size: 2rem;
    }
    p {
    font-family: Kalam;/** 'Reenie Beanie'; */
    font-size: 2rem;
    }
    ul{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    }
    ul li a{
    text-decoration:none;
    color:#000;
    background:#ffc;
    display:block;
    /* height:42em; */
    width:25em;
    padding:1em;
    box-shadow: 5px 5px 7px rgba(33,33,33,.7);
    transition: transform .15s linear;
    }
    ul li{
    margin:1em;
    }
    ul li a{
    transform: rotate(-6deg);
    }
    ul li:nth-child(even) a{
    transform:rotate(4deg);
    position:relative;
    top:5px;
    background:#cfc;
    }
    ul li:nth-child(3n) a{
    transform:rotate(-3deg);
    position:relative;
    top:-5px;
    background:#ccf;
    }
    ul li:nth-child(5n) a{
    transform:rotate(5deg);
    position:relative;
    top:-10px;
    }
    ul li a:hover,ul li a:focus{
    box-shadow:10px 10px 7px rgba(0,0,0,.7);
    transform: scale(1.25);
    position:relative;
    z-index:5;
    }
}
@media only screen and (max-width: 768px) {
 ul li a{
    text-decoration:none;
    color:#000;
    background:#ffc;
    display:block;
    /* height:25em; */
    width:15em;
    text-align: left;
    padding:.5em;
    box-shadow: 5px 5px 7px rgba(33,33,33,.7);
    text-overflow: clip;

    }
}

</style>
